<template>
  <b-card
    no-body
    class="border-primary"
  >
    <b-card-header class="d-flex justify-content-between align-items-center pt-75 pb-25">
      <h5 class="mb-0">
        {{ bankData.parent_name }}
      </h5>
      <small class="text-muted w-100">Caisse Parente</small>
    </b-card-header>

    <b-card-body>
      <ul class="list-unstyled my-1">
        <li>
          <span class="align-middle">{{ amountToCurrency(bankData.parent_balance, 'fr-FR', null) }} XOF</span>
        </li>
        <li class="my-25">
          <span class="align-middle">{{ bankData.siblings_count }} Sous-compte(s)</span>
        </li>
        <li>
          <span class="align-middle">Responsable : -------</span>
        </li>
      </ul>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        :to="{
          name: 'fund-histories-list',
          params: { id: bankData.parent_uid },
        }"
        variant="primary"
        block
      >
        Accéder <feather-icon icon="ArrowRightIcon" size="15" class="ml-50" />
      </b-button>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BBadge, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {amountToCurrency} from "../../../../utils/formatAmount";

export default {
  name: 'BankViewBankPlanCard',
  methods: {amountToCurrency},
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BBadge,
    BButton,
  },
  props: {
    bankData: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style>

</style>
